import {IconSize, iconStrokeWidthBySize} from '../icon_types';

type FileIconProps = {
  id?: string;
  className?: string;
  size: IconSize;
  color?: string;
};

const pathDsBySize = {
  '16': [
    'M8.6665 1.33337H3.99984C3.64622 1.33337 3.30708 1.47385 3.05703 1.7239C2.80698 1.97395 2.6665 2.31309 2.6665 2.66671V13.3334C2.6665 13.687 2.80698 14.0261 3.05703 14.2762C3.30708 14.5262 3.64622 14.6667 3.99984 14.6667H11.9998C12.3535 14.6667 12.6926 14.5262 12.9426 14.2762C13.1927 14.0261 13.3332 13.687 13.3332 13.3334V6.00004L8.6665 1.33337Z',
    'M8.6665 1.33337V6.00004H13.3332',
  ],
  '24': [
    'M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9L13 2Z',
    'M13 2V9H20',
  ],
  '32': [
    'M17.333 2.66675H7.99967C7.29243 2.66675 6.61415 2.9477 6.11406 3.4478C5.61396 3.94789 5.33301 4.62617 5.33301 5.33341V26.6667C5.33301 27.374 5.61396 28.0523 6.11406 28.5524C6.61415 29.0525 7.29243 29.3334 7.99967 29.3334H23.9997C24.7069 29.3334 25.3852 29.0525 25.8853 28.5524C26.3854 28.0523 26.6663 27.374 26.6663 26.6667V12.0001L17.333 2.66675Z',
    'M17.333 2.66675V12.0001H26.6663',
  ],
};

const FileIcon = (props: FileIconProps) => {
  const {id, className, size, color} = props;
  const paths = pathDsBySize[size];
  const colorOptions = color || 'currentColor' || '#1E1E20';

  return (
    <svg
      id={id}
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none">
      {paths.map((d, index) => (
        <path
          key={index}
          d={d}
          stroke={colorOptions}
          strokeWidth={iconStrokeWidthBySize[size]}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ))}
    </svg>
  );
};

export default FileIcon;
